export const images = [
  require("../assets/images/big-lightgallry/013.jpg"),
  require("../assets/images/big-lightgallry/015.jpg"),
  require("../assets/images/big-lightgallry/014.jpg"),
  require("../assets/images/big-lightgallry/016.jpg"),
  require("../assets/images/big-lightgallry/01.jpg"),
  require("../assets/images/big-lightgallry/04.jpg"),
  require("../assets/images/big-lightgallry/05.jpg"),
  require("../assets/images/big-lightgallry/06.jpg"),
  require("../assets/images/big-lightgallry/07.jpg"),
  require("../assets/images/big-lightgallry/08.jpg"),
  require("../assets/images/big-lightgallry/07.jpg"),
  require("../assets/images/big-lightgallry/08.jpg"),
];

export const smallImages = [
  require("../assets/images/lightgallry/013.jpg"),
  require("../assets/images/lightgallry/015.jpg"),
  require("../assets/images/lightgallry/014.jpg"),
  require("../assets/images/lightgallry/016.jpg"),
  require("../assets/images/lightgallry/01.jpg"),
  require("../assets/images/lightgallry/04.jpg"),
  require("../assets/images/lightgallry/05.jpg"),
  require("../assets/images/lightgallry/06.jpg"),
  require("../assets/images/lightgallry/07.jpg"),
  require("../assets/images/lightgallry/08.jpg"),
  require("../assets/images/lightgallry/07.jpg"),
  require("../assets/images/lightgallry/08.jpg"),
];
